import { HousekeepingStatus as e } from "@maat/api-main/types";
//#region src/housekeeping/housekeepingActions.ts
var t = /* @__PURE__ */ function(e) {
	return e.MarkDirty = "mark_dirty", e.MarkClean = "mark_clean", e.MarkInspected = "mark_inspected", e;
}({}), n = {
	[e.Dirty]: [t.MarkClean],
	[e.Clean]: [t.MarkInspected, t.MarkDirty],
	[e.Inspected]: [t.MarkDirty, t.MarkClean]
}, r = (e) => n[e];
//#endregion
export { t as HousekeepingAction, r as housekeepingActionsFor };
